import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';
// eslint-disable-next-line import/prefer-default-export
export const fetchProtectActions = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', 'protect-action/v1/actions'));

export const putProtectActions = (TYPE) => (id, archived) =>
    createAction(
        TYPE,
        createRequestPayload('international', `protect-action/v1/actions/${id}`, 'put', { archived }, { id, archived }),
    );

export const fetchProtectInfo = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', 'protect-action/v1/info'));

export const patchProtectInfo = (TYPE) => (data) =>
    createAction(TYPE, createRequestPayload('international', 'protect-action/v1/info', 'patch', data));

export const deleteProtectOptOut = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', '/protect-action/v1/opt-out', 'delete'));

export const fetchProtectMeta = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', 'protect-action/v1/meta'));

export const fetchProtectEmails = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', '/protect-action/v1/emails'));

export const addAdditionalEmail = (TYPE) => (data) =>
    createAction(TYPE, createRequestPayload('international', '/protect-action/v1/emails', 'post', data));

export const removeAdditionalEmail = (TYPE) => (emailId) =>
    createAction(TYPE, createRequestPayload('international', `/protect-action/v1/emails/${emailId}`, 'delete'));
